<div class="grid m-0">
  <div class="col-8 pl-5 my-0 p-0">
    <div class="flex align-items-center h-5rem">
      <div class="ml-3">
        <span class="orange-text">{{ title }}</span>
      </div>
    </div>
  </div>
  <div class="col-4 pr-5 p-0">
    <div
      class="flex align-items-center justify-content-end h-5rem text-right w-full"
    >
      <div
        class="flex align-items-center justify-content-end h-5rem text-right w-full pr-5"
      >
        <ng-container *ngFor="let item of data; let index = index">
          <p-button
            (onClick)="buttonClicked(data[index].icon)"
            [rounded]="true"
            [text]="true"
            [severity]="data[index].severity"
          >
            <ng-template pTemplate="icon">
              <div class="flex">
                <split-icon [name]="data[index].icon" [size]="20"></split-icon>
              </div>
            </ng-template>
          </p-button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
